module.exports = __webpack_public_path__ + "img/family-work.4dff455f.jpg";